import {useLocalStorage} from 'platform/components';

import {EmailCredentialsOwnerType, useStartMicrosoftOAuth2Mutation} from '@dms/api/core';
import {appWorkspaceKey} from '@dms/config';
import {buildUrl, microsoftOAuthRedirect} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {ApiError} from 'shared/web';

import {CONFIG_STORAGE_KEY} from '../constants/configStorageKey';

export type OAuthConfig = {
  ownerType?: EmailCredentialsOwnerType;
  purpose: 'email' | 'calendar';
};

export function useHandleSelectOAuthProvider(config: OAuthConfig) {
  const [startMicrosoftOAuth2] = useStartMicrosoftOAuth2Mutation();
  const [, setConfig] = useLocalStorage<OAuthConfig>(CONFIG_STORAGE_KEY, {purpose: 'email'});

  const startOAuth = (startLoading?: () => void, stopLoading?: () => void) => {
    const callbackUrl = buildUrl(microsoftOAuthRedirect, appWorkspaceKey, false);

    startLoading?.();
    startMicrosoftOAuth2({
      startMicrosoftOAuth2RequestBody: {
        callbackUrl,
        purposes: [config.purpose],
      },
    })
      .unwrap()
      .then(({authUrl}) => {
        setConfig(config);
        window.location.href = authUrl;
      })
      .catch((error) => {
        stopLoading?.();
        handleApiError(error as ApiError);
      });
  };

  return [startOAuth];
}
